import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {StoreProvider} from './store/StoreContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId="1069041377668-ae51f99bcvan3vu8pee1nnlhde0fs5p2.apps.googleusercontent.com">
        <StoreProvider>
            <React.StrictMode>
                {/* Small top-level link to HomeNotUsed page - clicking will navigate within SPA without full reload */}
                <div style={{padding: 8, textAlign: 'center'}}>

                </div>
                <App/>
            </React.StrictMode>
        </StoreProvider>
    </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
